module.exports = __webpack_public_path__ + "static/media/WorkExperiencePreparationSoftSkills.fcd0fa70.pdf";